(function() {
	'use strict';
	angular.module('telestatApp').factory('Division', Division);

	Division.$inject = [ '$resource' ];

	function Division($resource) {
		var resourceUrl = 'api/divisions/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'getforselect' : {
				method : 'GET',
				url : 'api/divisionsforselect',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();
